export enum PaginationKeysEnum {
  UNAVAILABLE_USERS_PAGINATION = "unavailable_users_pagination",
  LEARNING_PATH_PAGINATION = "learning_path_pagination",
  LEARNING_PATH_ATTENDEES_MODAL_PAGINATION = "learning_path_attendees_modal_pagination",
  LEARNING_PATH_ADD_ATTENDEES_MODAL_PAGINATION = "learning_path_add_attendees_modal_pagination",
  LEARNING_PATH_ATTENDEE_JOURNEY_PAGINATION = "learning_path_attendee_journey_pagination",
  LEARNING_PATH_TRAININGS_ATTENDEES_PAGINATION = "learning_path_trainings_attendees_pagination",
  // Session Details Pagination Keys
  ATTENDEES_PAGINATION = "attendees_pagination",
  UNSCHEDULE_USERS_PAGINATION = "unschedule_users_pagination",
  SESSION_NOTIFICATIONS_PAGINATION = "session_notifications_pagination",
  ADD_ATTENDEES_MODAL_PAGINATION = "add_attendees_modal_pagination",
  SESSION_WORKFLOWS_PAGINATION = "session_workflows_pagination",
  SESSION_DOCUMENTS_PAGINATION = "session_documents_pagination",
  LOG_AS_PAGINATION = "log_as_pagination",
  HOME_PAGINATION = "home_pagination",
  OTHER_COSTS_PAGINATION = "other_costs_pagination",
  SALARIES_COSTS_PAGINATION = "salaries_costs_pagination",
  COSTS_MANAGEMENT_PAGINATION = "costs_management_pagination",
  HABILITATIONS_PAGINATION = "habilitations_pagination",
  TIMESLOT_ATTENDEES_PAGINATION = "timeslot_attendees_pagination",
  DIGITAL_SIGN_IN_SHEET_ATTENDEES_PAGINATION = "digital_sign_in_sheet_attendees_pagination",
  DIGITAL_SIGN_IN_SHEET_TRAINERS_PAGINATION = "digital_sign_in_sheet_trainers_pagination",
  REQUESTS_PAGINATION = "requests_pagination",
  WORKFLOW_HABILITATION_PAGINATION = "workflow_habilitation_pagination",
  // Trainer portal: dedicated keys, or it would share its `usePagination` state with the admin session page.
  TRAINER_ATTENDEES_PAGINATION = "trainer_attendees_pagination",
  TRAINER_DOCUMENTS_PAGINATION = "trainer_documents_pagination",
  // User detail (fiche utilisateur) activity tabs
  USER_DETAIL_REQUESTS_PAGINATION = "user_detail_requests_pagination",
  USER_DETAIL_TRAININGS_PAGINATION = "user_detail_trainings_pagination",
  USER_DETAIL_LEARNING_PATHS_PAGINATION = "user_detail_learning_paths_pagination",
  USER_DETAIL_HABILITATIONS_PAGINATION = "user_detail_habilitations_pagination",
  // Settings
  FINANCING_MODES_PAGINATION = "financing_modes_pagination",
  HABILITATIONS_REFERENTIAL_PAGINATION = "habilitations_referential_pagination",
  WORKFLOWS_PAGINATION = "workflows_pagination",
  SIMBEL_CATALOG_PAGINATION = "simbel_catalog_pagination",
  BUDGET_PAGINATION = "budget_pagination",
  SATISFACTION_SURVEYS_PAGINATION = "satisfaction_surveys_pagination",
  EVALUATIONS_PAGINATION = "evaluations_pagination",
}
